var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticClass:"py-8"},[_c('CouponForm')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }